// NATIVE 
import React from 'react';


// INSTALLED 
import { Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import { useFormikContext } from 'formik';


// CUSTOM 
import InputField from '../../../formFields/InputField';
import TextAreaField from '../../../formFields/TextAreaField';
import AutocompleteField from '../../../formFields/autocompleteField';





/**
 * EditarArea component is responsible for rendering and managing the form fields
 * for editing an area. It utilizes Formik for form state management and Redux for
 * accessing the area data from the global state.
 *
 * @param {any} props - The properties passed to the component.
 * @returns {JSX.Element} The rendered component.
 *
 * @component
 * @example
 * const formField = {
 *   e_name: { name: 'name', label: 'Name' },
 *   e_description: { name: 'description', label: 'Description' }
 * };
 * return <EditarArea formField={formField} />;
 *
 * @remarks
 * This component uses the `useFormikContext` hook to access Formik's context and
 * the `useSelector` hook to access the Redux state. It also uses `useEffect` to
 * update the local state when the area data changes.
 *
 * @function setData - A helper function to set form field values based on the area data.
 *
 * @hook useFormikContext - To access Formik's context.
 * @hook useSelector - To access the Redux state.
 * @hook useState - To manage local state for the area data.
 * @hook useEffect - To update local state when the area data changes.
 */
export const EditarTerminalDescansos = (props:any) => {


    // USE FORMIK CONTEXT 
    const formikProps:any = useFormikContext();

  
    // USE SELECTOR 
    const { terminaldescansos }:any  = useSelector( (state:any) => state.terminalDescansos );


    // FORM FIELDS 
    const { formField: {
        name,
        description,
        typeTerminal
      }
    } = props;


    // USE STATE 
    const  [dataTerminal, setDataTerminal] = React.useState<any>(null);


    // USE EFFECT 
    React.useEffect(() => {
        setDataTerminal(terminaldescansos);
    }, [terminaldescansos])


    React.useEffect(() => {
        setData(terminaldescansos);
    }, [terminaldescansos]);


    // CONST FUNCTIONS 
    const setData = (terminal:any) => {

        // ID COMPANY 
      formikProps.setFieldValue('terminalId', terminal.id );

      // DATOS BASICOS
      formikProps.setFieldValue('name', terminal.name );
      formikProps.setFieldValue('description',  terminal.description );
      formikProps.setFieldValue('typeTerminal',  { label: terminal.typeTerminal, value: terminal.typeTerminal } );
    }

    const selectTerminal =  [
        { label: 'documento', value: 'Documento'},
        { label: 'facial', value: 'Facial'}
    ];


  return (
    <div>
        
        {
            dataTerminal &&  
              <>
                 <Grid>
                    <Grid size={{ xs: 12 }} sx={{ padding: 2 }}>
                        <InputField 
                            name={name.name}
                            label={name.label}
                            variant="outlined"
                            autoComplete="off" 
                            fullWidth
                        />
                    </Grid>
                </Grid>
                <Grid>
                    <Grid size={{ xs: 12 }} sx={{ padding: 2 }}>
                        <AutocompleteField
                            options={selectTerminal}
                            name={typeTerminal.name}
                            label={typeTerminal.label}
                            element={typeTerminal.name}
                        />
                    </Grid>
                </Grid>
                <Grid>
                    <Grid size={{ xs: 12 }} sx={{ padding: 2 }}>
                        <TextAreaField 
                            name={description.name}
                            label={description.label}
                            variant="outlined"
                            autoComplete="off" 
                            fullWidth
                        />
                    </Grid>
                </Grid>
              </>
        }
    </div>
  )
}
